import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	overflow: hidden;
`;
export const gridProducts = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-auto-rows: 1fr;
	gap: 0.5rem;
	padding: 0.5rem;
`;

export const infoSizeList = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	padding: 1rem;

	> p {
		color: ${color.interface.darkgray};
		font-size: 1.4rem;
	}
	> svg {
		color: ${color.interface.darkgray};
		font-size: 20px;
	}
`;

export const icon = styled.div`
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;

	> svg {
		font-size: 20px;
		width: fit-content;
		color: ${color.interface.darkgray};
	}
`;
